import { FC } from "react";
import Upsale from "./Upsale";
import TicketUpsaleType from "app/WebEvent/types/TicketUpsale";
import { useBasket, useBasketDispatch } from "../basketContext";
import { IWebTicket } from "app/WebEvent/interfaces";
import BasketReducerActions from "../enums/BasketReducerActions";

type TicketUpsaleProps = {
    upsale: TicketUpsaleType;
    ticket: IWebTicket;
};

const TicketUpsale: FC<TicketUpsaleProps> = ({ upsale, ticket }) => {
    const { tickets } = useBasket();
    const dispatch = useBasketDispatch();

    const basketUpsale = tickets
        .find((ticketItem) => ticketItem.id === ticket.id)
        ?.ticket_upsales.find((upsaleItem) => upsaleItem.id === upsale.id);

    const handleChange = (quantity: number) => {
        dispatch?.({
            type: BasketReducerActions.CHANGE_TICKET_UPSALE_QUANTITY,
            payload: {
                ticket,
                upsale,
                quantity,
            },
        });
    };

    return (
        <Upsale
            upsale={upsale}
            quantity={basketUpsale ? basketUpsale.quantity : 0}
            minQuantity={upsale.mandatory ? 1 : 0}
            onChange={handleChange}
        />
    );
};

export default TicketUpsale;
